const BOOKING_SOURCE_STORAGE_KEY = 'flox.bookingSource';
const WINGMAN = 'wingman';

export type BookingSource = typeof WINGMAN;

export function rememberBookingSourceFromUrl(search: string): void {
  const source = new URLSearchParams(search).get('source');
  if (source !== WINGMAN) return;
  try {
    window.sessionStorage.setItem(BOOKING_SOURCE_STORAGE_KEY, WINGMAN);
  } catch {
    return;
  }
}

export function forgetBookingSource(): void {
  try {
    window.sessionStorage.removeItem(BOOKING_SOURCE_STORAGE_KEY);
  } catch {
    return;
  }
}

export function readBookingSource(): BookingSource | null {
  try {
    const stored = window.sessionStorage.getItem(BOOKING_SOURCE_STORAGE_KEY);
    return stored === WINGMAN ? WINGMAN : null;
  } catch {
    return null;
  }
}
